module.exports = __webpack_public_path__ + "img/html-evolution-7.07383622.jpg";